export const routes = [
  {
    path: '/reting-effektivnosti-mpk',
    name: 'efficiencyrating',
    component: () => import('@/modules/mpkEffectiveRating/views/EfficiencyRating.vue'),
  },
];
